<template>
  <!--  页面头部-->
  <div class="header-box">
    <div class="logo-box">
      <div class="logo">
        欢迎来到国家眼科专业质控中心！
      </div>
      <div class="login-box">
        <div class="information">
          <img src="@/assets/images/h1.png" />
          <span>下载APP</span>
          <!--二维码-->
          <div class="code-box">
            <img src="@/assets/images/code.png"/>
            <div class="code-p">扫码下载眼科质控APP</div>
          </div>
        </div>
        <div class="login-bt" v-if="userInfo.id == undefined" @click="goLogin">登录/注册</div>
        <el-dropdown v-if="userInfo.id != undefined" @command="onClickLogOut">
          <div class="login-user-header" @click.stop="goUserInfo">
            <div class="user-img">
              <img v-if="userInfo.avatar && userInfo.avatar.url != undefined" :src="userInfo.avatar.url" alt="">
              <img
                v-else
                src="@/assets/images/user.png"
                alt="默认头像"
              />
            </div>
            <div class="user-name" v-if="userInfo.doctor && userInfo.doctor.doctorName != undefined">{{ userInfo.doctor.doctorName }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoReadCount } from '@/api/user'

export default {
  name: "siteNav",
  data() {
    return {
      userInfo: {},
      noReadCount: 0
    }
  },
  methods: {
    goLogin() {
      this.$router.push({ path: `/codeLogin` })
    },
    goUserInfo() {
      this.$router.push({ path: `/PersonalCenter` })
    },
    getNoReadCount() {
      getNoReadCount().then(res => {
        this.noReadCount = res.data[0]
      })
    },
    onClickLogOut() {
      localStorage.removeItem("x-token")
      localStorage.removeItem("userInfo")
      this.$router.push({ path: `/codeLogin` })
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")) : {}
    this.getNoReadCount()
  }
}
</script>

<style lang="less">
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #FFFFFF !important;
  color: #9C1D22 !important;
}

.header-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background: rgba(164, 18, 24, 1);
  color: #fff;

  .login-box {
    display: flex;
    align-items: center;

    .login-bt {
      font-size: 14px;
      line-height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .login-user-header {
      display: flex;
      align-items: center;
      cursor: pointer;

      .user-img {
        width: 26px;
        height: 26px;
        vertical-align: bottom;
        border-radius: 50%;
        margin-right: 8px;
        img{
          width: 100%;
          height: 100%;
        }
      }

      .user-name {
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        color: #FFFFFF;
      }
    }
  }
  .information:hover{
    .code-box{
      display: block;
    }
  }
  .information {
    display: flex;
    align-items: center;
    font-size: 14px;
    border-right: 1px solid #fff;
    height: 10px;
    margin-right: 24px;
    padding-right: 24px;
    cursor: pointer;
    position: relative;

    img {
      width: 16px;
    }
    .code-box{
      top: 25px;
      left: -75px;
      position: absolute;
      text-align: center;
      box-shadow: 0px 4px 32px 0px #0000001A;
      width: 250px;
      background: #fff;
      z-index: 999;
      padding: 24px 0;
      display: none;
      img{
        width: 186px;
        display: block;
        margin: auto;
      }
      .code-p{
        color: #262626;
        font-size: 16px;
        line-height: 20px;
        margin-top: 9px;
      ;
      }
    }
  }

  .logo-box {
    width: 1300px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/headerBar.vue